import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Share/Layout';
import { Home } from './components/Pages/Home';
import { Children } from './components/Pages/Children';
import Login from './components/Pages/Login';
import { PrivateRoute } from './components/Share/PrivateRoute';
import { UserProfile } from './components/Admin/UserProfile';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faIgloo } from '@fortawesome/free-solid-svg-icons'
import Logout from './components/Pages/Logout';
import {Roles} from './components/Admin/Roles';
import { Users } from './components/Admin/Users';
import { ForgotPassword } from './components/Pages/ForgotPassword';
import { ResetPassword } from './components/Pages/ResetPassword';
import { Timelines } from './components/Pages/Timelines';
import { MediaTimelines } from './components/Pages/MediaTimelines';
import { ChartSMS } from './components/Pages/ChartSMS';
import { Register } from './components/Pages/Register';
import { Survey } from './components/Pages/Survey';
import { PrivacyPolicy } from './components/Pages/PrivacyPolicy';


library.add(faIgloo)

export default class App extends Component {
  displayName = App.name
  
  constructor(props) {
    super(props);
  
    this.state = {
      isAuthenticated: false
    };
  }
  
  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }
  
  render() {
    if(localStorage.getItem('roleType')==='1'){//admin
      return (
        <Layout>
          <PrivateRoute exact path="/" component={Home} />
          <Route path='/privacy-policy' component={PrivacyPolicy} />
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/forgotpassword' component={ForgotPassword} />
          <Route path='/register' component={Register} />
          <Route path='/resetpassword/:userId' component={ResetPassword} />
          <PrivateRoute path='/userprofile' component={UserProfile} />
          <PrivateRoute path='/users' component={Users} />
          <PrivateRoute path='/children' component={Children} />
          <PrivateRoute path='/roles' component={Roles}/>
          <PrivateRoute path='/timeline' component={Timelines}/>
          <PrivateRoute path='/mediaTimeline' component={MediaTimelines}/>
          <PrivateRoute path='/chartSMS' component={ChartSMS}/>
          <PrivateRoute path='/survey' component={Survey}/>
        </Layout>
      );
    }
    else if(localStorage.getItem('roleType')==='2'){//parent
      return (
        <Layout>
          <PrivateRoute exact path="/" component={Home} />
          <Route path='/privacy-policy' component={PrivacyPolicy} />
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/forgotpassword' component={ForgotPassword} />
          <Route path='/register' component={Register} />
          <Route path='/resetpassword/:userId' component={ResetPassword} />
          <PrivateRoute path='/userprofile' component={UserProfile} />
          <PrivateRoute path='/users' component={Users} />
          <PrivateRoute path='/children' component={Children} />
          <PrivateRoute path='/timeline' component={Timelines}/>
          <PrivateRoute path='/mediaTimeline' component={MediaTimelines}/>
          <PrivateRoute path='/chartSMS' component={ChartSMS}/>
          <PrivateRoute path='/survey' component={Survey}/>
        </Layout>
      );
    }
    else if(localStorage.getItem('roleType')==='3'){//Therapist
      return (
        <Layout>
          <PrivateRoute exact path="/" component={Home} />
          <Route path='/privacy-policy' component={PrivacyPolicy} />
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/forgotpassword' component={ForgotPassword} />
          <Route path='/register' component={Register} />
          <Route path='/resetpassword/:userId' component={ResetPassword} />
          <PrivateRoute path='/userprofile' component={UserProfile} />
          <PrivateRoute path='/timeline' component={Timelines}/>
          <PrivateRoute path='/mediaTimeline' component={MediaTimelines}/>
          <PrivateRoute path='/chartSMS' component={ChartSMS}/>
        </Layout>
      );
    }
    else if(localStorage.getItem('roleType')==='4'){//Caregiver
      return (
        <Layout>
          <PrivateRoute exact path="/" component={Home} />
          <Route path='/privacy-policy' component={PrivacyPolicy} />
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/forgotpassword' component={ForgotPassword} />
          <Route path='/register' component={Register} />
          <Route path='/resetpassword/:userId' component={ResetPassword} />
          <PrivateRoute path='/userprofile' component={UserProfile} />
          <PrivateRoute path='/timeline' component={Timelines}/>
          <PrivateRoute path='/mediaTimeline' component={MediaTimelines}/>
          <PrivateRoute path='/chartSMS' component={ChartSMS}/>
        </Layout>
      );
    }
    else{
      return (
        <Layout>
          <PrivateRoute exact path="/" component={Home} />
          <Route path='/privacy-policy' component={PrivacyPolicy} />
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/forgotpassword' component={ForgotPassword} />
          <Route path='/register' component={Register} />
          <Route path='/resetpassword/:userId' component={ResetPassword} />
        </Layout>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.js